'use strict';

angular.module('app')
  .controller('WishListCtrl', function ($scope, $location, typeURL, Wishlist, Search, utils) {
    var vm = this;

    vm.current = typeURL;
    vm.limit = 3;
    vm.search = Search;
    vm.goToFavorite = goToFavorite;

    Wishlist.get().then(function (data) {
      vm.list = data;
    });

    vm.triggerWishlist = function (e, result, parent) {
      e.stopPropagation();
      e.preventDefault();

      var data = {
          item_type: result.model,
          item_slug: result.slug,
        },
        type = 'add';

      if (!parent.deleted) {
        data = parent.id;
        type = 'delete';
      }

      Wishlist[type](data).then(function (data) {
        if (type == 'add') {
          parent.deleted = false;
          parent.id = data.item.id;
        } else {
          parent.deleted = true;
        }
      });
    };

    function goToFavorite(url) {
      window.location.href = url;
    }
  })
;
